<div class="language-table">
	<div class="language-table__header">
		<typography
			variant="p/xxs_semibold"
			class="language-table__cell language-table__cell--label"
		>
			Word
		</typography>
		<typography variant="p/xxs_semibold" class="language-table__cell">
			Sentiment
		</typography>
		<typography
			variant="p/xxs_semibold"
			class="language-table__cell language-table__cell--source"
		>
			Source
		</typography>
		<typography
			variant="p/xxs_semibold"
			class="language-table__cell language-table__cell--count"
		>
			Count
		</typography>
	</div>
	<div class="language-table__row" *ngFor="let term of terms">
		<typography
			variant="p/sm_medium"
			class="language-table__cell language-table__cell--label language-table__word"
		>
			{{ term.word }}
		</typography>
		<div class="language-table__cell language-table__bar-wrap">
			<div class="language-table__bar-track">
				<div
					class="language-table__bar-fill"
					[class.language-table__bar-fill--positive]="
						term.sentiment === 'positive'
					"
					[class.language-table__bar-fill--negative]="
						term.sentiment === 'negative'
					"
					[style.width.%]="term.percentage"
				></div>
			</div>
		</div>
		<typography
			variant="p/xxs_regular"
			class="language-table__cell language-table__cell--source language-table__source"
		>
			{{ sourceLabel(term.source) }}
		</typography>
		<typography
			variant="p/xxs_regular"
			class="language-table__cell language-table__cell--count language-table__count"
		>
			{{ term.count | number }}
		</typography>
	</div>
</div>
